import React from "react";
function Card(props) {
  const { image, text, styleCard } = props;

  return (
    <div className={`CardBenefit ${styleCard}`}>
      <img src={image} alt={image} />
      {text && <p>{text}</p>}
      {props.children}
    </div>
  );
}

export default Card;
